module.exports = __webpack_public_path__ + "media/assets/images/flags/pe-002ebb625eb76698ab639c218b7a0722.svg";